'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n'], ['\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  margin-left: 6px;\n'], ['\n  margin-left: 6px;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _View = require('../../atoms/View');

var _View2 = _interopRequireDefault(_View);

var _ErrorMsg = require('../../atoms/ErrorMsg');

var _ErrorMsg2 = _interopRequireDefault(_ErrorMsg);

var _Link = require('../../atoms/Link');

var _Link2 = _interopRequireDefault(_Link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Content = (0, _styledComponents2.default)(_View2.default)(_templateObject);

var Callout = (0, _styledComponents2.default)(_Link2.default)(_templateObject2);

var errorMsgCallout = function errorMsgCallout(props) {
  return _react2.default.createElement(
    Content,
    null,
    _react2.default.createElement(
      _ErrorMsg2.default,
      null,
      props.text
    ),
    _react2.default.createElement(
      Callout,
      { type: 'primary', underline: true, href: props.href },
      props.linkText
    )
  );
};

errorMsgCallout.propTypes = {
  text: _propTypes2.default.string.isRequired,
  linkText: _propTypes2.default.string.isRequired,
  href: _propTypes2.default.string.isRequired
};

exports.default = errorMsgCallout;